export default {
  title: "Venue",
  capacity: "Capacity",
  form: {
    capacity: "Maximum capacity",
    capacityPlaceholder: "Maximum number of seats",
    errors: {
      capacityPositive: "Capacity must be a positive number"
    }
  }
};

